import {FunctionComponent, createContext, useContext, PropsWithChildren} from 'react';
import {isNotBlankOrEmpty} from '@/engine/utils/string';

interface ElementProps {
  isDisabled?: boolean;
  isInError?: boolean;
  isRequired?: boolean;
  errors?: string[];
  warningMessage?: string;
}

interface Context {
  isInError: boolean;
  isRequired: boolean;
  isDisabled: boolean;
  hasWarning: boolean;
  errors?: string[];
  warningMessage?: string;
}

const FormControlContext = createContext<Context>({
  isRequired: false,
  isDisabled: false,
  isInError: false,
  hasWarning: false,
});

// eslint-disable-next-line react-refresh/only-export-components
export const useFormControlContext = () => useContext(FormControlContext);

const FormControl: FunctionComponent<PropsWithChildren<ElementProps>> = ({
  children,
  isInError = false,
  isDisabled = false,
  isRequired = false,
  errors,
  warningMessage,
}) => {
  const hasWarning = isNotBlankOrEmpty(warningMessage);

  return (
    <FormControlContext.Provider value={{isDisabled, isInError, isRequired, hasWarning, errors, warningMessage}}>
      {children}
    </FormControlContext.Provider>
  );
};

export default FormControl;
